import { render, staticRenderFns } from "./HeroHeader.vue?vue&type=template&id=6a2a56b3&"
import script from "./HeroHeader.vue?vue&type=script&lang=js&"
export * from "./HeroHeader.vue?vue&type=script&lang=js&"
import style0 from "./HeroHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports